import React from 'react';
import LegalPageLayout from '../components/LegalPageLayout';

const ImpresszumPage = () => (
  <LegalPageLayout
    testId="impresszum-page"
    title="Impresszum"
    metaDescription="A szolgáltató, tárhelyszolgáltató és online fizetési szolgáltató adatai – Orosz Coaching."
    canonicalPath="/impresszum"
    updatedAt="2026-02-15"
  >
    <section>
      <h2 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>
        A szolgáltató adatai
      </h2>
      <ul className="list-disc pl-6 space-y-1.5 text-[15px]">
        <li><strong>A szolgáltató neve:</strong> Orosz Gábor</li>
        <li><strong>A szolgáltató székhelye:</strong> Magyarország, 3530 Miskolc, Dankó Pista utca 27. 5/1.</li>
        <li><strong>A szolgáltató elérhetősége, elektronikus levelezőcíme:</strong>{' '}
          <a href="mailto:info@oroszcoaching.hu" className="text-yellow-700 hover:text-yellow-600 font-semibold">info@oroszcoaching.hu</a>
        </li>
        <li><strong>A szolgáltató telefonszáma:</strong>{' '}
          <a href="tel:+36702378299" className="text-gray-900">+36 70 237 8299</a>
        </li>
        <li><strong>Nyilvántartási szám / Cégjegyzékszám:</strong> 62408259</li>
        <li><strong>Adószám:</strong> 92117709-1-25</li>
        <li><strong>A nyilvántartásban bejegyző hatóság:</strong> Nemzeti Adó- és Vámhivatal / Okmányiroda</li>
      </ul>
    </section>

    <section>
      <h2 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>
        Tárhelyszolgáltató adatai
      </h2>
      <ul className="list-disc pl-6 space-y-1.5 text-[15px]">
        <li><strong>Név:</strong> Rackhost Zrt.</li>
        <li><strong>Székhely:</strong> 6722 Szeged, Tisza Lajos körút 41.</li>
        <li><strong>Elérhetőség:</strong>{' '}
          <a href="mailto:info@rackhost.hu" className="text-yellow-700 hover:text-yellow-600 font-semibold">info@rackhost.hu</a>,{' '}
          <a href="tel:+3614452040" className="text-gray-900">+36 1 445 2040</a>
        </li>
      </ul>
    </section>

    <section>
      <h2 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>
        Online fizetési szolgáltató adatai
      </h2>
      <ul className="list-disc pl-6 space-y-1.5 text-[15px]">
        <li><strong>Név:</strong> Barion Payment Zrt.</li>
        <li><strong>Székhely:</strong> 1117 Budapest, Infopark sétány 1. I. épület 5. emelet</li>
        <li><strong>Működési engedély száma:</strong> H-EN-I-1064/2013 (MNB)</li>
      </ul>
    </section>
  </LegalPageLayout>
);

export default ImpresszumPage;
